export default () => ({
  schema: {
    blocks: {
      // For now, only allow list-item-child to have text or inlines as nodes.
      // This simplifies a lot of logic around manipulating lists, but should
      // be updated to support other children (like images) in the future.
      "list-item-child": {
        nodes: [
          {
            match: [{ object: "text" }, { object: "inline" }]
          }
        ],
        normalize: (editor, error) => {
          switch (error.code) {
            case "child_object_invalid":
              error.child.nodes.forEach((node, index) => {
                editor.moveNodeByKey(node.key, error.node.key, index)
              })
              editor.removeNodeByKey(error.child.key)
              return
            default:
              return
          }
        }
      },
      paragraph: {},
      image: {
        // Automatically wrap `image` with `captioned-image`.
        parent: { type: "captioned-image" },
        normalize: (editor, error) => {
          switch (error.code) {
            case "parent_type_invalid": {
              const { width, margin, alignment } = error.node.data.toJS()

              return editor.wrapNodeByKey(error.node.key, {
                object: "block",
                type: "captioned-image",
                data: { width, margin, alignment }
              })
            }
            default:
              return
          }
        }
      },
      "captioned-image": {
        // Lift `captioned-image` up to the root document.
        parent: { object: "document" },
        normalize: (editor, error) => {
          switch (error.code) {
            case "parent_object_invalid": {
              const ancestor = editor.value.document.getParent(error.parent.key)
              const index = ancestor.nodes.indexOf(error.parent)

              editor.moveNodeByKey(error.node.key, ancestor.key, index)
              return
            }
            default:
              return
          }
        }
      },
      video: {
        isVoid: true
      },
      "horizontal-rule": {
        isVoid: true
      }
    },
    inlines: {
      // Automatically remove empty links
      link: {
        text: /^(?!\s*$).+/
      }
    }
  }
})
